<modal
  [id]="id()"
  [header]="headerTitle()"
  [headerIcon]="headerIcon()"
  [closeButtonEnabled]="true"
  [showFooterDivider]="false"
  [widthClass]="'tw-w-[calc(100%-32px)] tw-max-w-[343px]'"
  [heightClass]="'tw-h-auto'"
  [enableBackdropClose]="true"
  (onCloseModal)="onModalClose()"
>
  <div slot="body" class="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-8 tw-font-inter">
    <app-invitation-channel-history-body
      class="tw-w-full"
      [channel]="channel()"
      [entries]="activeHistory()?.entries ?? []"
      [isLoading]="activeHistory()?.isLoading ?? false"
      [isLoadingMore]="activeHistory()?.isLoadingMore ?? false"
      [hasMore]="activeHistory()?.hasMore ?? false"
      variant="light"
      maxHeightClass="tw-max-h-[280px]"
      (loadMore)="loadMoreHistory.emit()"
    />

    @if (showSendCta()) {
      <button
        type="button"
        class="tw-flex tw-h-[41px] tw-w-full tw-shrink-0 tw-items-center tw-justify-center tw-gap-2 tw-overflow-hidden tw-rounded-lg tw-border-0 tw-bg-blue-600 tw-px-5 tw-py-2.5 hover:tw-bg-blue-700"
        [disabled]="isSending()"
        (click)="onSendInvitation()"
      >
        <img
          src="assets/images/v2/invitation-channel-popover/send-invitation-light.svg"
          alt=""
          class="tw-h-3.5 tw-w-3.5 tw-shrink-0"
          width="14"
          height="14"
        />
        <span class="tw-whitespace-nowrap tw-text-sm tw-font-medium tw-leading-normal tw-text-white">{{ sendCtaLabel() }}</span>
      </button>
    } @else if (blockedSendReason()) {
      <div
        class="tw-flex tw-w-full tw-shrink-0 tw-items-start tw-gap-2 tw-rounded-lg tw-border tw-p-3"
        [ngClass]="blockedSendBannerClass()"
        role="status"
      >
        <img
          [src]="blockedSendIconSrc()"
          alt=""
          class="tw-mt-0.5 tw-h-5 tw-w-5 tw-shrink-0"
          width="20"
          height="20"
        />
        <p class="tw-m-0 tw-text-xs tw-font-medium tw-leading-normal tw-text-gray-900 tw-font-inter">{{ blockedSendMessage() }}</p>
      </div>
    }
  </div>
</modal>
